module.exports = __webpack_public_path__ + "img/vps_pattern.1721c89.png";